// extracted by mini-css-extract-plugin
export default {"title":"MasterSaleDetails_title__U1Meh","total":"MasterSaleDetails_total__vmb-P","edit":"MasterSaleDetails_edit__pMycT","cancel":"MasterSaleDetails_cancel__OC3mX"};